"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutPage = void 0;
var react_1 = __importDefault(require("react"));
// import { useHistory } from 'react-router-dom'
var UserManager_1 = __importDefault(require("App/util/UserManager"));
var Loader_1 = __importDefault(require("App/components/Loader"));
exports.LogoutPage = function () {
    // const history = useHistory()
    react_1.default.useEffect(function () {
        console.log('removing user..');
        UserManager_1.default
            .removeUser()
            .then(function () {
            UserManager_1.default.signoutRedirect().catch(function (reason) {
                console.error('signoutRedirect() Error caught', reason);
            });
        })
            .catch(function (reason) {
            console.error('removeUser() Error caught:', reason);
        });
    }, []);
    return react_1.default.createElement(Loader_1.default, null);
};
exports.default = {
    name: 'Logout',
    routeProps: {
        path: '/logout',
        component: exports.LogoutPage,
    },
};
//# sourceMappingURL=logout.js.map